import styled from "styled-components";
import { theme } from "../../styles/theme";

export const UserContainer = styled.section`
    padding: 50px 0;
    background: #ffffff;
    max-width: 400px;
    height: auto;
    margin: auto;

    .index-usuarios{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .loadmore{
            margin: 30px 0;
            padding: 15px 20px;
        }
    }

    .container-center{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        button {
            margin-left: 0px;
        }

        .salvar {
            width: 100%;
            max-width: 400px;
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
            
            a {
                width: 35%;
                text-decoration: none;
            }

            .salvado {
                width: 60%;
                margin: 30px 0;
                padding: 15px 20px;
            }
        }

        .adicionar{
            width: 100%;
            max-width: 400px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .add{
                width: 146px;
                text-align: center;
                font-family: Lato;
                font-size: 11px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #589bff;
                cursor: pointer;
                position: absolute;
                margin-top: 15px;
                margin-left: 85px;
                .click{
                    position: absolute;
                    margin-left: 240px;
                    margin-top: 35px;
                    width: 80px;
                }
            }
        }

    }

    .search{
        display: flex;
        flex-direction: row;
        margin-left: 190px;
        margin-top: -80px;
        margin-bottom: 20px;
        
        a {
            margin-left: 90px;
            margin-top: -12px;
            text-decoration: none;
        
            button {
                border-radius: 30px;
                border: solid 3px #FFF;
                margin: 15px 0 30px;
                padding: 15px 30px;
            }
        }



        .add{
            margin-left: 90px;
            margin-top: -10px;
            display: flex;
            align-items: center;
            z-index: 2;

        }
    }
    .search-select{
        width: 500px;
        display: flex;
        flex-direction: row;
        margin-top: -110px;

        .add{
            margin-left: 90px;
            margin-top: 8px;
  
        }

    }

    @media only screen and (max-width: 991px){
        .container-center{
            .salvar{
                flex-direction: column;


                a {
                    width: 100%;
                    margin: auto;
                    margin-bottom: 10px;
                }

                .salvado {
                    width: 100%;
                    margin: auto;
                    padding: 15px 20px;
                }


                button{
                    width: 100%
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
    .search {
            display: flex;
            flex-direction: row;
            margin-left: 0;
            margin-top: -80px;
            align-items: center;
        }

        a {
            padding: 10px;
            width: 100%;
            max-width: 500px;
            margin-bottom: 10px;
        }
    
        .container-center{

            .adicionar{
                width: 100%;
                max-width: 400px;
                display: flex;
                flex-direction: row;
                .add{
                    width: 146px;
                    text-align: center;
                    margin-top: auto;
                    padding-bottom: 22px;
                    margin-left: 10px;
                    font-family: Lato;
                    font-size: 11px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #589bff;
                    cursor: pointer;
                    position: absolute;
                    margin-top: 17px;
                    margin-left: 160px;
                    .click{ 
                        position: absolute;
                        margin-top: 0px;
                        margin-left: -30px;
                        width: 210px;
                    }
                }
            }
        }
    }
    


`;

export const UserIndexContainer = styled.section`
    padding: 50px 0;
    background: #ffffff;
    width: 100%;
    height: auto;
    margin: auto;

    .index-usuarios{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .loadmore{
            margin: 30px 0;
            padding: 15px 20px;
        }
    }

    .container-center{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        button {
            margin-left: 0px;
        }

        .salvar {
            width: 100%;
            max-width: 400px;
            margin-top: 20px;
            display: flex;
            justify-content: space-around;
            
            a {
                width: 35%;
                text-decoration: none;
            }

            .salvado {
                width: 60%;
                margin: 30px 0;
                padding: 15px 20px;
            }
        }

        .adicionar{
            width: 100%;
            max-width: 400px;
            display: flex;
            flex-direction: row;
            justify-content: center;
            .add{
                width: 146px;
                text-align: center;
                font-family: Lato;
                font-size: 11px;
                font-weight: bold;
                font-stretch: normal;
                font-style: normal;
                line-height: normal;
                letter-spacing: normal;
                color: #589bff;
                cursor: pointer;
                position: absolute;
                margin-top: 15px;
                margin-left: 85px;
                .click{
                    position: absolute;
                    margin-left: 240px;
                    margin-top: 35px;
                    width: 80px;
                }
            }
        }

    }

    .search{
        display: flex;
        flex-direction: row;
        margin-left: 190px;
        margin-top: -80px;
        margin-bottom: 20px;
        
        a {
            margin-left: 90px;
            margin-top: -12px;
            text-decoration: none;
        
            button {
                border-radius: 30px;
                border: solid 3px #FFF;
                margin: 15px 0 30px;
                padding: 15px 30px;
            }
        }



        .add{
            margin-left: 90px;
            margin-top: -10px;
            display: flex;
            align-items: center;
            z-index: 2;

        }
    }
    .search-select{
        width: 500px;
        display: flex;
        flex-direction: row;
        margin-top: -110px;

        .add{
            margin-left: 90px;
            margin-top: 8px;
  
        }

    }

    @media only screen and (max-width: 991px){
        .container-center{
            .salvar{
                flex-direction: column;


                a {
                    width: 100%;
                    margin: auto;
                    margin-bottom: 10px;
                }

                .salvado {
                    width: 100%;
                    margin: auto;
                    padding: 15px 20px;
                }


                button{
                    width: 100%
                }
            }
        }
    }

    @media only screen and (max-width: 768px) {
    .search {
            display: flex;
            flex-direction: row;
            margin-left: 0;
            margin-top: 30px;
            align-items: center;
        }

        a {
            padding: 10px;
            width: 100%;
            max-width: 500px;
            margin-bottom: 10px;
        }
    
        .container-center{

            .adicionar{
                width: 100%;
                max-width: 400px;
                display: flex;
                flex-direction: row;
                .add{
                    width: 146px;
                    text-align: center;
                    margin-top: auto;
                    padding-bottom: 22px;
                    margin-left: 10px;
                    font-family: Lato;
                    font-size: 11px;
                    font-weight: bold;
                    font-stretch: normal;
                    font-style: normal;
                    line-height: normal;
                    letter-spacing: normal;
                    color: #589bff;
                    cursor: pointer;
                    position: absolute;
                    margin-top: 17px;
                    margin-left: 160px;
                    .click{ 
                        position: absolute;
                        margin-top: 0px;
                        margin-left: -30px;
                        width: 210px;
                    }
                }
            }
        }
    }

`;

export const ContainerInput = styled.div`
    width: 100%;
    height: auto;


    display: flex;
    flex-direction: row;
    justify-content: center;

    >div>div{
        width: 195px;

        left: 360px;

        @media (max-width: 990px) {
            left: 25%;
        }
    }

     @media (max-width: 990px) {
        height: 115px;
    }
`;

export const ContainerSelect = styled.div`
    width: 100%;
    height: auto;


    display: flex;
    flex-direction: row;
    justify-content: flex-start;
`;

export const ContainerWarning = styled.div`
    width: 100%;
    height: auto;

    gap: 16px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;

    >img {
        width: 175px;
        height: auto;
    }

    >p{
        text-align: center;
    }
`;

export const ContainerModalNewUser = styled.div`
    width: 420px;
    height: auto;

    gap: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerModalFormNewUser = styled.div`
    width: 100%;
    height: auto;

    gap: 24px;
    display: flex;
    align-items: center;
    flex-direction: column;
`;

export const ContainerDetails = styled.div`
    width: auto;
    height: auto;


    gap: 8px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;


`;

export const ContainerContentAcordion= styled.div`
    width: 100%;
    height: auto;


    gap: 40px;
    display: flex;
    justify-content: flex-start;

    @media (max-width: 760px) {
        gap: 16px;
        flex-direction: column;

        >div>p{
         width: fit-content;
        }
    }
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating {
    from {
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  @keyframes rotating {
    from {
      -ms-transform: rotate(0deg);
      -moz-transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
      -o-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    to {
      -ms-transform: rotate(360deg);
      -moz-transform: rotate(360deg);
      -webkit-transform: rotate(360deg);
      -o-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  width: 64px;
  height: 64px;
  position: relative;
  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Bandeira};
  border-bottom: 1px solid ${theme.colors.green.Bandeira};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;